
import Image from 'react-bootstrap/Image';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import im_WhoWeAre from "../static/images/im_WhoWeAre.jpg"
import "../style/App.css";
import "../style/Home.css";
import "../style/ReactBootstrapOverride.css";



const WhoWeAre = () => {

    return (
        <Container className="px-5 mx-5">
            <Row className='h-25'>
                <Col>
                    <Image style={{ width: 440, height: 'auto' }} src={im_WhoWeAre} alt="im_WhoWeAre" fluid rounded></Image>
                </Col>
                <Col>
                    <Row>
                        <h1>WHO WE ARE</h1>
                    </Row>
                    <Row>
                        <p>
                            CFI surgery is a team of surgeons, doctors, and engineers that have revolutionised surgical skills training.
                        </p>
                        <p>
                            We accelerate and improve training using advanced imaging and automation tools for assessment and feedback.
                        </p>
                        <p>
                            We relieve the administrative and operational burden of training from senior surgeons so that they may focus on the important task of passing on their knowledge and expertise.
                        </p>        
                    </Row>
                </Col>
            </Row>
        </Container>
    );
}

export default WhoWeAre;